import React from 'react';
import { Route, Switch, Link, Redirect } from 'react-router-dom';
import LoginForm from './LoginForm';
import { Demo, RouteBasic, RouteVariable, RouteUnprotected, } from '../Wrappers';
import CreateAccount from './CreateAccount';
import NavBarLegacy from '../../components/unprotected/NavBarLegacy';
import FourOhFour from '../RoutesProtected/FourOhFour';
import ForgotPassword from './ForgotPassword/enteremail'
import ChangePassword from './PasswordReset';
import SetPassword from './PasswordSet';
import SignUpThankYou from './Signup_ThankYou';
import { Base, WhiteLabelApplications, AccountAccess, Min, AccountAccessGeneric } from '../Layouts';
import AccountSetupPassword from './AccountSetup';
import ApplicationPayoffRequest from './ApplicationPayoffRequest';
// import ThankYouWhiteLabel from './ThankYouWhiteLabel';

export default function RoutesUnprotected(props) {

    return (
        <>
            <div>
                <NavBarLegacy />
            </div>

            <Route path="/">
                <Switch>
               
                    <RouteUnprotected exact={true}
                        path={"/"}
                        {...props}
                        component={LoginForm}
                        layout={AccountAccess}
                        layoutVariant={"centered"}
                    />


                    <Route
                        path="broker/signup"
                        exact={true}
                        render={({ location }) => {
                            const queryString = location.search;
                            const destinationUrl = `https://www.limaone.com/apply-now/${queryString}`;
                            window.location.href = destinationUrl;
                            return null;
                        }}
                    />

                    <Route
                        path="/signup"
                        exact={true}
                        render={({ location }) => {
                            const queryString = location.search;
                            const destinationUrl = `https://www.limaone.com/apply-now/${queryString}`;
                            window.location.href = destinationUrl;
                            return null;
                        }}
                    />
                    
                    <RouteBasic layout={AccountAccess} layoutVariant="centered" path="/signup-thankyou" title="Thank You" component={SignUpThankYou} {...props} info={''} />

                    {/* Create account routes */}
                    <RouteBasic
                        layout={AccountAccess}
                        path="/create-account/:email"
                        component={CreateAccount}
                        layoutVariant={"centered"}
                        title={"Create Account"}
                        {...props} />

                    <RouteBasic
                        layout={AccountAccess}
                        layoutVariant={"centered"}
                        path="/create-account"
                        component={CreateAccount}
                        title={"Create Account"}
                        {...props} />

                    {/* Password setting routes */}
                    <RouteBasic path="/account-setup/:token"
                        layout={AccountAccess}
                        component={AccountSetupPassword}
                                title={"Account Setup"}
                        {...props} />

                    <RouteBasic 
                        layout={AccountAccess}
                        layoutVariant={"centered"} path="/set-password/:token" title="Set Password" component={SetPassword} {...props} />

                    <RouteBasic
                        layout={AccountAccess}
                        layoutVariant={"centered"}
                        path="/forgot-password"
                        component={ForgotPassword}
                        title={"Forgot Password"}
                        {...props} />

                    <RouteBasic
                        layout={AccountAccess}
                        layoutVariant={"centered"} path="/change-password/:token" title={"Change Password"} component={ChangePassword} {...props} />

                    <RouteBasic path={`/applications/payoff-request`} component={ApplicationPayoffRequest} layout={WhiteLabelApplications} external={true} {...props} />

                    {/* 404 route */}
                    <RouteBasic layout={AccountAccessGeneric} path component={FourOhFour} {...props} title="Resource Not Found" />
                </Switch>
            </Route>
        </>
    )
}